export function readableLayerName(name: string): string {
	const spaced = name.replace(/_-_/g, ' – ').replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
	if (spaced !== spaced.toUpperCase()) return spaced;

	const lower = spaced.toLowerCase();
	const firstLetter = lower.search(/[a-zà-ÿ]/);

	return -1 === firstLetter ? lower : lower.slice(0, firstLetter) + lower[firstLetter]!.toUpperCase() + lower.slice(firstLetter + 1);
}
